var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile"},[_c('h2',[_vm._v("Profile")]),_vm._l((_vm.profile),function(subtitle,index){return _c('span',{key:index,staticClass:"subtitle"},[_vm._v("\n    "+_vm._s(subtitle)+"\n    "),_c('br')])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }